<template>
  <div>
    <ValidationProvider
      :name="$t('labels.status')"
      :rules="rules"
      v-slot="{ errors }"
    >
      <v-select
        :items="data || statusItems"
        :disabled="disabled"
        :label="$t('labels.status')"
        :error-messages="errors[0]"
        :value="value"
        :multiple="multiple"
        @change="onChange"
        :item-text="itemText || 'label'"
        :item-value="itemValue || 'value'"
        v-bind="$attrs"
      ></v-select>
    </ValidationProvider>
  </div>
</template>

<script>
import GroupService from "../services/GroupService";

export default {
  name: "StatusSelect",
  methods: {
    onChange(inputValue) {
      this.$emit("input", inputValue);
      this.$emit("change", inputValue);
    },
  },
  mounted() {
    
  },

  computed: {
    statusItems(){
      let items = [
        {
          value: null,
          label: 'Tümü'
        },
        {
          value: 0,
          label: 'Taslak'
        },
        {
          value: 10,
          label: 'Yayında'
        },
        {
          value: 20,
          label: 'Pasif'
        },
        {
          value: 30,
          label: 'Silinmiş'
        },
      ];
      
      const inactives = this.inactiveValues;
      if(Array.isArray(inactives) && inactives.length > 0){
        items = items.filter(item => !inactives.includes(item.value))
      }

      return items;
    }
  },

  props: {
    data: {
      type:  Array,
      default: null,
    },

    value: {
      type: [String, Number, Array],
      default: null,
    },

    rules: {
      type: [Object, String],
      default: () => ({
        required: false
      })
    },

    inactiveValues: {
      type: [Array],
      default: () => [],
    },

    itemText: {
      type: [String],
      default: null,
    },

    itemValue: {
      type: [String],
      default: null,
    },

    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
